import { render, staticRenderFns } from "./OfficialNewsModal.vue?vue&type=template&id=aa785ffa&scoped=true"
import script from "./OfficialNewsModal.vue?vue&type=script&lang=js"
export * from "./OfficialNewsModal.vue?vue&type=script&lang=js"
import style0 from "./OfficialNewsModal.vue?vue&type=style&index=0&id=aa785ffa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa785ffa",
  null
  
)

export default component.exports